export default {
  // Common translations
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.search': 'Search',
  'common.reset': 'Reset',
  'common.submit': 'Submit',
  'common.close': 'Close',

  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  // Staff Management
  'pages.staffManagement.title': 'Staff Management',
  'pages.staffManagement.staffList': 'Staff List',
  'pages.staffManagement.addStaff': 'Add Staff',
  'pages.staffManagement.editStaff': 'Edit Staff',
  'pages.staffManagement.exportExcel': 'Export Excel',
  'pages.staffManagement.exportTooltip':
    'Export staff data to Excel (CSV format with UTF-8 encoding)',
  'pages.staffManagement.exportSuccess':
    'Staff list exported successfully! For best Chinese character display, open in Excel and ensure UTF-8 encoding is selected.',
  'pages.staffManagement.staffCreated': 'Staff created successfully!',
  'pages.staffManagement.staffUpdated': 'Staff updated successfully!',
  'pages.staffManagement.staffDeleted': 'Staff deleted successfully!',
  'pages.staffManagement.deleteFailed': 'Failed to delete staff',
  'pages.staffManagement.deleteStaff': 'Delete Staff',
  'pages.staffManagement.deleteConfirmTitle': 'Delete Staff',
  'pages.staffManagement.deleteConfirmDescription':
    'Are you sure you want to delete {name}? This action cannot be undone.',
  'pages.staffManagement.deleteConfirm': 'Yes',
  'pages.staffManagement.deleteCancel': 'No',
  'pages.staffManagement.viewAssignments': 'View Staff Assignments',
  'pages.staffManagement.operationFailed': 'Operation failed',
  'pages.staffManagement.accessDenied': 'Access Denied',
  // Staff Form Fields
  'pages.staffManagement.employeeId': 'Employee ID',
  'pages.staffManagement.employeeIdPlaceholder': 'Search Employee ID',
  'pages.staffManagement.employeeIdRequired': 'Please input Employee ID',
  'pages.staffManagement.firstName': 'First Name',
  'pages.staffManagement.firstNamePlaceholder': 'Search First Name',
  'pages.staffManagement.firstNameRequired': 'Please input First Name',
  'pages.staffManagement.lastName': 'Last Name',
  'pages.staffManagement.lastNamePlaceholder': 'Search Last Name',
  'pages.staffManagement.lastNameRequired': 'Please input Last Name',
  // Transaction Management
  'transaction.title': 'Transaction Management',
  'transaction.createTitle': 'Create Transaction',
  'transaction.editTitle': 'Edit Transaction',
  'transaction.description': 'Description',
  'transaction.descriptionRequired': 'Please input description',
  'transaction.amount': 'Amount',
  'transaction.amountRequired': 'Please input amount',
  'transaction.currency': 'Currency',
  'transaction.category': 'Category',
  'transaction.categoryRequired': 'Please select a category',
  'transaction.selectCategory': 'Select a category',
  'transaction.unit': 'Unit',
  'transaction.selectUnit': 'Select a unit',
  'transaction.referenceType': 'Reference Type',
  'transaction.referenceId': 'Reference ID',
  'transaction.transactionDate': 'Transaction Date',
  'transaction.status': 'Status',
  'transaction.attachment': 'Attachment',
  'transaction.uploadImage': 'Upload Image',
  'transaction.income': 'Income',
  'transaction.expense': 'Expense',
  'transaction.createSuccess': 'Transaction created successfully!',
  'transaction.updateSuccess': 'Transaction updated successfully!',
  'transaction.operationFailed': 'Transaction operation failed',
  'transaction.deleteSuccess': 'Transaction deleted successfully!',
  'transaction.deleteFailed': 'Failed to delete transaction',
  'transaction.deleteConfirm': 'Are you sure to delete this transaction?',
  'transaction.yes': 'Yes',
  'transaction.no': 'No',
  'transaction.cancel': 'Cancel',
  'transaction.approveSuccess': 'Transaction approved successfully',
  'transaction.rejectSuccess': 'Transaction rejected successfully',
  'transaction.cancelSuccess': 'Transaction cancelled successfully',
  'transaction.confirmApproveTitle': 'Confirm Approval',
  'transaction.confirmApproveContent':
    'Are you sure you want to approve this transaction? This action cannot be undone.',
  'transaction.confirmRejectTitle': 'Confirm Rejection',
  'transaction.confirmRejectContent':
    'Are you sure you want to reject this transaction? This action cannot be undone.',
  'transaction.confirmCancelTitle': 'Confirm Cancellation',
  'transaction.confirmCancelContent':
    'Are you sure you want to cancel this transaction? This action cannot be undone.',
  'transaction.transactionDetails': 'Transaction Details',
  'transaction.noDescription': 'No description',
  'transaction.cancelAction': 'Cancel',
  'occurrenceBook.title': 'Occurrence Book',
  'occurrenceBookRecord.title': 'Occurrence Book Record',
  'unitModal.unitNumber': 'Unit Number',
  'patrolRoute.modalTitle': 'Patrol Route',
  'patrolRoute.name': 'Route Name',
  'patrolRoute.nameRequired': 'Route name is required',
  'patrolRoute.namePlaceholder': 'Enter route name',
  'patrolRoute.description': 'Description',
  'patrolRoute.descriptionPlaceholder': 'Enter description',
  'patrolRoute.daysEnabled': 'Days Enabled',
  'patrolRoute.monday': 'Monday',
  'patrolRoute.tuesday': 'Tuesday',
  'patrolRoute.wednesday': 'Wednesday',
  'patrolRoute.thursday': 'Thursday',
  'patrolRoute.friday': 'Friday',
  'patrolRoute.saturday': 'Saturday',
  'patrolRoute.sunday': 'Sunday',
  'patrolRoute.sequence': 'Sequence',
  'patrolRoute.checkpoint': 'Checkpoint',
  'patrolRoute.referenceCode': 'Reference Code',
  'patrolRoute.expectedTime': 'Expected Time',
  'patrolRoute.tolerance': 'Tolerance',
  'patrolRoute.required': 'Required',
  'patrolRoute.notes': 'Notes',
  'patrolRoute.action': 'Action',
  'patrolRoute.checkpointsTitle': 'Checkpoints',
  'patrolRoute.addCheckpoint': 'Add Checkpoint',
  'patrolRoute.checkpointModalTitle': 'Checkpoint Details',
  'patrolRoute.checkpointRequired': 'Checkpoint is required',
  'patrolRoute.selectCheckpoint': 'Select Checkpoint',
  'patrolRoute.expectedTimeRequired': 'Expected time is required',
  'siteDetail.addDevice': 'Add Device',
  'siteDetail.deviceName': 'Device Name',
  'siteDetail.deviceNameRequired': 'Device name is required',
  'siteDetail.deviceType': 'Device Type',
  'siteDetail.deviceTypeRequired': 'Device type is required',
  'siteDetail.deviceModel': 'Device Model',
  'siteDetail.deviceSerial': 'Device Serial',
  'siteDetail.macAddress': 'MAC Address',
  'siteDetail.ipAddress': 'IP Address',
  'siteDetail.locationDescription': 'Location Description',
  'siteDetail.floorLevel': 'Floor Level',
  'siteDetail.zoneArea': 'Zone Area',
  'siteDetail.username': 'Username',
  'siteDetail.usernameRequired': 'Username is required',
  'siteDetail.email': 'Email',
  'siteDetail.emailRequired': 'Email is required',
  'siteDetail.password': 'Password',
  'siteDetail.passwordRequired': 'Password is required',
  'siteDetail.autoLogin': 'Auto Login',
  'siteDetail.offlineMode': 'Offline Mode',
  'siteDetail.syncInterval': 'Sync Interval',
  'siteDetail.installationDate': 'Installation Date',
  'siteDetail.warrantyExpiry': 'Warranty Expiry',
  'siteDetail.maintenanceSchedule': 'Maintenance Schedule',
  'siteDetail.notes': 'Notes',
  'siteDetail.installationNotes': 'Installation Notes',
  'siteDetail.troubleshootingNotes': 'Troubleshooting Notes',
  'siteDetail.deviceStatus': 'Device Status',
  'siteDetail.accessLevel': 'Access Level',
  'siteDetail.authToken': 'Auth Token',
  'siteDetail.lastHeartbeat': 'Last Heartbeat',
  'siteDetail.actions': 'Actions',
  'siteDetail.incidentManagement': 'Incident Management',
  'siteDetail.patrolRouteManagementTitle': 'Patrol Route Management',
  'siteDetail.daysEnabled': 'Days Enabled',
  'siteDetail.deviceManagement': 'Device Management',
  'siteDetail.startTime': 'Start Time',
  'siteDetail.endTime': 'End Time',
  'occurrenceBook.new': 'New Occurrence Book',
  'occurrenceBook.edit': 'Edit Occurrence Book',
  'occurrenceBook.id': 'ID',
  'occurrenceBook.checkpoint': 'Checkpoint',
  'occurrenceBook.expectedTime': 'Expected Time',
  'occurrenceBook.assignedAt': 'Assigned At',
  'occurrenceBook.action': 'Action',
  'occurrenceBook.shift': 'Shift',
  'occurrenceBook.selectCheckpoint': 'Select checkpoint',
  'occurrenceBook.selectShift': 'Select shift',
  'occurrenceBook.tolerance': 'Tolerance (minutes)',
  'occurrenceBook.failedToFetch': 'Failed to fetch occurrence books',
  'occurrenceBook.deleted': 'Deleted',
  'occurrenceBook.updated': 'Updated',
  'occurrenceBook.created': 'Created',
  'occurrenceBookRecord.new': 'New Occurrence Book Record',
  'occurrenceBookRecord.edit': 'Edit Occurrence Book Record',
  'occurrenceBookRecord.id': 'ID',
  'occurrenceBookRecord.obNumber': 'OB Number',
  'occurrenceBookRecord.attendanceId': 'Attendance ID',
  'occurrenceBookRecord.expectedTime': 'Expected Time',
  'occurrenceBookRecord.checkpoint': 'Checkpoint',
  'occurrenceBookRecord.attendanceTimestamp': 'Attendance Timestamp',
  'occurrenceBookRecord.action': 'Action',
  'occurrenceBookRecord.occurrenceBook': 'Occurrence Book',
  'occurrenceBookRecord.selectOccurrenceBook': 'Select Occurrence Book',
  'occurrenceBookRecord.staff': 'Staff',
  'occurrenceBookRecord.selectStaff': 'Select Staff',
  'occurrenceBookRecord.selectCheckpoint': 'Select Checkpoint',
  'occurrenceBookRecord.approved': 'Approved',
  'occurrenceBookRecord.timestamp': 'Timestamp',
  'occurrenceBookRecord.failedToFetch': 'Failed to fetch occurrence book records',
  'occurrenceBookRecord.deleted': 'Deleted',
  'occurrenceBookRecord.updated': 'Updated',
  'occurrenceBookRecord.created': 'Created',
  'occurrenceBookRecord.dateRange': 'Date Range',
  'occurrenceBookRecord.selectApprovalStatus': 'All',
  'occurrenceBookRecord.notApproved': 'Not Approved',
  'occurrenceBookRecord.filter': 'Filter',
  'occurrenceBookRecord.reset': 'Reset',
  'transaction.create': 'Create',
  'transaction.update': 'Update',
  'transaction.delete': 'Delete',
  'transaction.edit': 'Edit',
  'transaction.actions': 'Actions',
  'transaction.showing': 'Showing',
  'transaction.of': 'of',
  'transaction.items': 'items',
  'transaction.search': 'Search',
  'transaction.reset': 'Reset',
  'transaction.filter': 'Filter',
  'transaction.export': 'Export',
  'transaction.import': 'Import',
  'transaction.refresh': 'Refresh',
  'transaction.details': 'Details',
  'transaction.viewDetails': 'View Details',
  'transaction.detailTitle': 'Transaction Details',
  'transaction.close': 'Close',
  'transaction.openFullSize': 'Open Full Size',
  'transaction.viewImage': 'View Image',
  'transaction.view': 'View',
  'transaction.pending': 'Pending',
  'transaction.approved': 'Approved',
  'transaction.rejected': 'Rejected',
  'transaction.cancelled': 'Cancelled',
  'transaction.status.pending': 'Pending',
  'transaction.status.approved': 'Approved',
  'transaction.status.rejected': 'Rejected',
  'transaction.status.cancelled': 'Cancelled',
  // Transaction Categories
  'transaction.category.income': 'Income',
  'transaction.category.expenses': 'Expenses',
  'transaction.category.investmentIncome': 'Investment Income',
  'transaction.category.interest': 'Interest',
  'transaction.category.capitalGains': 'Capital Gains',
  'transaction.category.dividends': 'Dividends',
  'transaction.category.rentIncome': 'Rent Income',
  'transaction.category.equipmentRental': 'Equipment Rental',
  'transaction.category.residentialRent': 'Residential Rent',
  'transaction.category.commercialRent': 'Commercial Rent',
  'transaction.category.otherIncome': 'Other Income',
  'transaction.category.donationsReceived': 'Donations Received',
  'transaction.category.grants': 'Grants',
  'transaction.category.miscellaneousIncome': 'Miscellaneous Income',
  'transaction.category.royalties': 'Royalties',
  'transaction.category.sales': 'Sales',
  'transaction.category.productSales': 'Product Sales',
  'transaction.category.onlineSales': 'Online Sales',
  'transaction.category.serviceSales': 'Service Sales',
  'transaction.category.wholesaleSales': 'Wholesale Sales',
  'transaction.category.operatingExpenses': 'Operating Expenses',
  'transaction.category.rent': 'Rent',
  'transaction.category.officeRent': 'Office Rent',
  'transaction.category.warehouseRent': 'Warehouse Rent',
  'transaction.category.equipmentLease': 'Equipment Lease',
  'transaction.category.salariesWages': 'Salaries & Wages',
  'transaction.category.fullTimeEmployees': 'Full-Time Employees',
  'transaction.category.contractors': 'Contractors',
  'transaction.category.partTimeEmployees': 'Part-Time Employees',
  'transaction.category.advertisingMarketing': 'Advertising & Marketing',
  'transaction.category.digitalAdvertising': 'Digital Advertising',
  'transaction.category.eventSponsorships': 'Event Sponsorships',
  'transaction.category.printAdvertising': 'Print Advertising',
  'transaction.category.financialExpenses': 'Financial Expenses',
  'transaction.category.loanInterest': 'Loan Interest',
  'transaction.category.creditCardCharges': 'Credit Card Charges',
  'transaction.category.bankFees': 'Bank Fees',
  'transaction.category.depreciationAmortization': 'Depreciation & Amortization',
  'transaction.category.equipmentDepreciation': 'Equipment Depreciation',
  'transaction.category.buildingDepreciation': 'Building Depreciation',
  'transaction.category.otherExpenses': 'Other Expenses',
  'transaction.category.taxes': 'Taxes',
  'transaction.category.salesTax': 'Sales Tax',
  'transaction.category.incomeTax': 'Income Tax',
  'transaction.category.propertyTax': 'Property Tax',
  'transaction.category.miscellaneousExpenses': 'Miscellaneous Expenses',
  'transaction.category.repairsMaintenance': 'Repairs & Maintenance',
  'transaction.category.administrativeExpenses': 'Administrative Expenses',
  'transaction.category.officeSupplies': 'Office Supplies',
  'transaction.category.utilities': 'Utilities',
  'transaction.category.internetPhone': 'Internet & Phone',
  'transaction.category.electricity': 'Electricity',
  'transaction.category.water': 'Water',
  'transaction.category.professionalFees': 'Professional Fees',
  'transaction.category.accountingFees': 'Accounting Fees',
  'transaction.category.legalFees': 'Legal Fees',
  'pages.staffManagement.name': 'Name',
  'pages.staffManagement.staffTitle': 'Title',
  'pages.staffManagement.titlePlaceholder': 'Select title',
  'pages.staffManagement.gender': 'Gender',
  'pages.staffManagement.genderPlaceholder': 'Select gender',
  'pages.staffManagement.male': 'Male',
  'pages.staffManagement.female': 'Female',
  'pages.staffManagement.other': 'Other',
  'pages.staffManagement.phone': 'Phone',
  'pages.staffManagement.phonePlaceholder': 'Search Phone',
  'pages.staffManagement.hkidNumber': 'HKID Number',
  'pages.staffManagement.hkidNumberPlaceholder': 'Search HKID',
  'pages.staffManagement.age': 'Age',
  'pages.staffManagement.securityLicense': 'Security License',
  'pages.staffManagement.securityLicensePlaceholder': 'Search License',
  'pages.staffManagement.securityLicenseNumber': 'Security License Number',
  'pages.staffManagement.securityLicenseAExpiry': 'Security License A Expiry',
  'pages.staffManagement.securityLicenseBExpiry': 'Security License B Expiry',
  'pages.staffManagement.qasCertificateIssueDate': 'QAS Certificate Issue Date',
  'pages.staffManagement.medicalReportIssueDate': 'Medical Report Issue Date (65+)',
  'pages.staffManagement.employmentStatus': 'Employment Status',
  'pages.staffManagement.employmentStatusPlaceholder': 'Select status',
  'pages.staffManagement.contractType': 'Contract Type',
  'pages.staffManagement.contractTypePlaceholder': 'Select contract type',
  'pages.staffManagement.contractTypeDescription': 'Contract Type Description',
  'pages.staffManagement.contractType.permanent': 'Permanent (Indefinite) Employment Contract',
  'pages.staffManagement.contractType.fixed_term': 'Fixed-Term Employment Contract',
  'pages.staffManagement.contractType.temporary': 'Temporary Employment Contract',
  'pages.staffManagement.contractType.part_time': 'Part-Time Employment Contract',
  'pages.staffManagement.contractType.casual': 'Casual Employment Contract',

  // Site Gate Management
  'siteDetail.gateManagementTitle': 'Gate Management',
  'siteDetail.addGate': 'Add Gate',
  'siteDetail.editGate': 'Edit Gate',
  'siteDetail.deleteGate': 'Delete Gate',
  'siteDetail.gateName': 'Gate Name',
  'siteDetail.gateType': 'Gate Type',
  'siteDetail.passcode': 'Passcode',
  'siteDetail.gateType.main': 'Main Gate',
  'siteDetail.gateType.service': 'Service Gate',
  'siteDetail.gateType.emergency': 'Emergency Gate',
  'siteDetail.gateType.pedestrian': 'Pedestrian Gate',
  'siteDetail.gateType.vehicle': 'Vehicle Gate',
  'siteDetail.gateCreated': 'Gate created successfully!',
  'siteDetail.gateUpdated': 'Gate updated successfully!',
  'siteDetail.gateDeleted': 'Gate deleted successfully!',
  'siteDetail.gateDeleteFailed': 'Failed to delete gate',
  'siteDetail.gateOperationFailed': 'Gate operation failed',
  'siteDetail.deleteGateConfirmTitle': 'Delete Gate',
  'siteDetail.deleteGateConfirmDescription':
    'Are you sure you want to delete this gate? This action cannot be undone.',
  'siteDetail.deleteGateConfirm': 'Yes',
  'siteDetail.deleteGateCancel': 'No',
  'siteDetail.gateNameRequired': 'Please enter gate name',
  'siteDetail.gateTypeRequired': 'Please select gate type',
  'siteDetail.eventManagement': 'Event Management',
  'siteDetail.shiftCalendar': 'Shift Calendar',
  'siteDetail.viewShiftCalendar': 'View Shift Calendar',

  // Shift Assignment Import
  'shiftAssignment.clearAndReplaceMode': 'Clear and Replace Mode',
  'shiftAssignment.clearAndReplaceDescription':
    'Existing assignments and leaves for this month were cleared before importing new data.',
  'shiftAssignment.clearedData': 'Cleared Data',
  'shiftAssignment.clearedAssignments': 'Cleared Assignments',
  'shiftAssignment.clearedLeaves': 'Cleared Leaves',
  'shiftAssignment.assignments': 'Assignments',
  'shiftAssignment.leaves': 'Leaves',
  'shiftAssignment.totalLeaves': 'Total Leaves',
  'shiftAssignment.createdLeaves': 'Created Leaves',
  'shiftAssignment.skippedLeaves': 'Skipped Leaves',
  'shiftAssignment.totalConflicts': 'Total Conflicts',

  // Shift Assignment Export
  'shiftAssignment.exportExcel': 'Export Excel',
  'shiftAssignment.exportSuccess': 'Export completed successfully',
  'shiftAssignment.exportError': 'Export failed',
  'shiftAssignment.siteName': 'Site Name',
  'shiftAssignment.shiftName': 'Shift Name',
  'shiftAssignment.timeRange': 'Time Range',
  'shiftAssignment.region': 'Region',
  'shiftAssignment.district': 'District',
  'shiftAssignment.fileTooLarge': 'File must be smaller than 50MB!',
  'shiftAssignment.fileRequirements': 'Support .xlsx and .xls files, max 50MB',
  'shiftAssignment.monthPicker': 'Select Month',
  'shiftAssignment.filterByRegion': 'Filter by Region',
  'shiftAssignment.filterByDistrict': 'Filter by District',
  'shiftAssignment.filterBySite': 'Filter by Site',
  'shiftAssignment.search': 'Search',

  // Shift Assignment Import Conflicts
  'shiftAssignment.conflictsReportTitle': 'Import Conflicts Report',
  'shiftAssignment.conflictsReportGenerated': 'Generated',
  'shiftAssignment.conflictNumber': 'Conflict #{number}',
  'shiftAssignment.conflictType': 'Type',
  'shiftAssignment.conflictDescription': 'Description',
  'shiftAssignment.staff': 'Staff',
  'shiftAssignment.site': 'Site',
  'shiftAssignment.shift': 'Shift',
  'shiftAssignment.date': 'Date',
  'shiftAssignment.downloadConflicts': 'Download Conflicts Report',
  'shiftAssignment.conflictsDownloaded': 'Conflicts report downloaded',

  // Shift Assignment Staffing Issues Export
  'shiftAssignment.exportIssues': 'Export Issues',
  'shiftAssignment.staffingIssuesReportTitle': 'Staffing Issues Report',
  'shiftAssignment.reportPeriod': 'Period',
  'shiftAssignment.totalIssues': 'Total Issues Found: {count}',
  'shiftAssignment.issueNumber': 'Issue #{number}',
  'shiftAssignment.issueType': 'Issue Type',
  'shiftAssignment.staffingLevel': 'Staffing Level',
  'shiftAssignment.overstaffed': 'Over-staffed',
  'shiftAssignment.understaffed': 'Under-staffed',
  'shiftAssignment.criticallyUnderstaffed': 'Critically Under-staffed',
  'shiftAssignment.severityWarning': 'WARNING',
  'shiftAssignment.severityCritical': 'CRITICAL',
  'shiftAssignment.severityHigh': 'HIGH',
  'shiftAssignment.noIssuesFound': 'No staffing issues found. All shifts are properly staffed.',
  'shiftAssignment.issuesExported': 'Staffing issues report exported',

  // Shift Detail
  'shiftDetail.updateLeave': 'Update Leave',
  'shiftDetail.deleteLeave': 'Delete Leave',
  'shiftDetail.sunday': 'Sunday',
  'shiftDetail.backToShiftAssignment': 'Back to Shift Assignment',
  'shiftDetail.legend': 'Legend',
  'shiftDetail.holiday': 'Holiday',
  'shiftDetail.regularDay': 'Regular Day',
  'shiftDetail.statutoryHoliday': 'Statutory Holiday',
  'shiftDetail.noPayLeave': 'No Pay Leave',
  'shiftDetail.regularHoliday': 'Regular Holiday',
  'shiftDetail.compensationLeave': 'Compensation Leave',
  'shiftDetail.absenceWithoutLeave': 'Absence Without Leave',
  'shiftDetail.unpaidSickLeave': 'Unpaid Sick Leave',
  'shiftDetail.search': 'Search',

  'pages.staffManagement.employmentStartDate': 'Employment Start Date',
  'pages.staffManagement.employmentEndDate': 'Employment End Date',
  'pages.staffManagement.employmentStartRange': 'Employment Start Range',
  'pages.staffManagement.licenseAExpiryRange': 'License A Expiry Range',
  'pages.staffManagement.site': 'Site',
  'pages.staffManagement.sitePlaceholder': 'Filter by Site',
  'pages.staffManagement.address': 'Address',
  'pages.staffManagement.emergencyContact': 'Emergency Contact',
  'pages.staffManagement.emergencyPhone': 'Emergency Phone',
  'pages.staffManagement.email': 'Email',
  'pages.staffManagement.emailInvalid': 'Please enter a valid email',
  'pages.staffManagement.password': 'Password',
  'pages.staffManagement.active': 'Active',
  'pages.staffManagement.inactive': 'Inactive',
  'pages.staffManagement.status': 'Status',
  'pages.staffManagement.createdAt': 'Created At',
  'pages.staffManagement.updatedAt': 'Updated At',
  // Employment Status
  'pages.staffManagement.statusActive': 'Active',
  'pages.staffManagement.statusResigned': 'Resigned',
  'pages.staffManagement.statusTerminated': 'Terminated',
  // Date Placeholders
  'pages.staffManagement.startDate': 'Start Date',
  'pages.staffManagement.endDate': 'End Date',
  'pages.staffManagement.dateOfBirth': 'Date of Birth',
  // Site Notice Management
  'pages.siteNoticeManagement.pageTitle': 'Site Notices',
  'pages.siteNoticeManagement.noticeList': 'Notice List',
  'pages.siteNoticeManagement.addNotice': 'Add Notice',
  'pages.siteNoticeManagement.editNotice': 'Edit Notice',
  'pages.siteNoticeManagement.deleteNotice': 'Delete Notice',
  'pages.siteNoticeManagement.noticeCreated': 'Notice created successfully!',
  'pages.siteNoticeManagement.noticeUpdated': 'Notice updated successfully!',
  'pages.siteNoticeManagement.noticeDeleted': 'Notice deleted successfully!',
  'pages.siteNoticeManagement.operationFailed': 'Operation failed',
  'pages.siteNoticeManagement.confirmDelete': 'Are you sure you want to delete this notice?',
  'pages.siteNoticeManagement.confirmDeleteTitle': 'Delete Notice',
  // Site Notice Form Fields
  'pages.siteNoticeManagement.title': 'Title',
  'pages.siteNoticeManagement.titlePlaceholder': 'Enter notice title',
  'pages.siteNoticeManagement.titleRequired': 'Please enter notice title',
  'pages.siteNoticeManagement.content': 'Content',
  'pages.siteNoticeManagement.contentPlaceholder': 'Enter notice content',
  'pages.siteNoticeManagement.contentRequired': 'Please enter notice content',
  'pages.siteNoticeManagement.site': 'Site',
  'pages.siteNoticeManagement.sitePlaceholder': 'Select site',
  'pages.siteNoticeManagement.siteRequired': 'Please select a site',
  'pages.siteNoticeManagement.priority': 'Priority',
  'pages.siteNoticeManagement.priorityPlaceholder': 'Select priority',
  'pages.siteNoticeManagement.priorityLow': 'Low',
  'pages.siteNoticeManagement.priorityNormal': 'Normal',
  'pages.siteNoticeManagement.priorityHigh': 'High',
  'pages.siteNoticeManagement.priorityUrgent': 'Urgent',
  'pages.siteNoticeManagement.isPublished': 'Published',
  'pages.siteNoticeManagement.isActive': 'Active',
  'pages.siteNoticeManagement.expiresAt': 'Expires At',
  'pages.siteNoticeManagement.expiresAtPlaceholder': 'Select expiration date',
  'pages.siteNoticeManagement.attachments': 'Attachments',
  'pages.siteNoticeManagement.addAttachment': 'Add Attachment',
  'pages.siteNoticeManagement.removeAttachment': 'Remove Attachment',
  'pages.siteNoticeManagement.noAttachments': 'No attachments',
  // Site Notice Table Columns
  'pages.siteNoticeManagement.columnTitle': 'Title',
  'pages.siteNoticeManagement.columnSite': 'Site',
  'pages.siteNoticeManagement.columnPriority': 'Priority',
  'pages.siteNoticeManagement.columnStatus': 'Status',
  'pages.siteNoticeManagement.columnPublished': 'Published',
  'pages.siteNoticeManagement.columnCreatedBy': 'Created By',
  'pages.siteNoticeManagement.columnCreatedAt': 'Created At',
  'pages.siteNoticeManagement.columnExpiresAt': 'Expires At',
  'pages.siteNoticeManagement.columnActions': 'Actions',
  // Site Notice Status
  'pages.siteNoticeManagement.statusPublished': 'Published',
  'pages.siteNoticeManagement.statusDraft': 'Draft',
  'pages.siteNoticeManagement.statusActive': 'Active',
  'pages.siteNoticeManagement.statusInactive': 'Inactive',
  'pages.siteNoticeManagement.statusExpired': 'Expired',
  // Site Notice Priority Colors
  'pages.siteNoticeManagement.priorityColorLow': 'blue',
  'pages.siteNoticeManagement.priorityColorNormal': 'green',
  'pages.siteNoticeManagement.priorityColorHigh': 'orange',
  'pages.siteNoticeManagement.priorityColorUrgent': 'red',
  // Patrol Route Management
  'pages.siteDetail.patrolRouteManagementTitle': 'Patrol Routes',
  'pages.siteDetail.addPatrolRoute': 'Add Patrol Route',
  'pages.siteDetail.editPatrolRoute': 'Edit Patrol Route',
  'pages.siteDetail.deletePatrolRoute': 'Delete Patrol Route',
  'pages.siteDetail.patrolRouteName': 'Route Name',
  'pages.siteDetail.patrolRouteDescription': 'Description',
  'pages.siteDetail.daysEnabled': 'Days Enabled',
  'pages.siteDetail.monday': 'Monday',
  'pages.siteDetail.tuesday': 'Tuesday',
  'pages.siteDetail.wednesday': 'Wednesday',
  'pages.siteDetail.thursday': 'Thursday',
  'pages.siteDetail.friday': 'Friday',
  'pages.siteDetail.saturday': 'Saturday',
  'pages.siteDetail.sunday': 'Sunday',
  'pages.siteDetail.manageCheckpoints': 'Manage Checkpoints',
  'pages.siteDetail.patrolRouteCreated': 'Patrol route created successfully',
  'pages.siteDetail.patrolRouteUpdated': 'Patrol route updated successfully',
  'pages.siteDetail.patrolRouteDeleted': 'Patrol route deleted successfully',
  'pages.siteDetail.confirmDeletePatrolRoute': 'Are you sure you want to delete this patrol route?',
  'pages.siteDetail.confirmDeletePatrolRouteTitle': 'Delete Patrol Route',
  // Tenant Management
  'tenantManagement.title': 'Tenant Management',
  'tenantManagement.content': 'Manage system tenants and their information',
  'tenantManagement.tenantList': 'Tenant List',
  'tenantManagement.createNewTenant': 'Create New Tenant',
  'tenantManagement.createTenant': 'Create Tenant',
  'tenantManagement.editTenant': 'Edit Tenant',
  'tenantManagement.deleteTenant': 'Delete Tenant',
  'tenantManagement.viewTenant': 'View Tenant',
  'tenantManagement.tenantCreated': 'Tenant created successfully',
  'tenantManagement.tenantUpdated': 'Tenant updated successfully',
  'tenantManagement.tenantDeleted': 'Tenant deleted successfully',
  'tenantManagement.saveTenantFailed': 'Failed to save tenant',
  'tenantManagement.deleteTenantFailed': 'Failed to delete tenant',
  'tenantManagement.fetchSitesFailed': 'Failed to fetch sites',
  'tenantManagement.userAccountCreated': 'User account created. Please save the credentials.',
  'tenantManagement.accessDenied': 'Access Denied',
  // Tenant Form Fields
  'tenantManagement.name': 'Name',
  'tenantManagement.searchName': 'Search by name',
  'tenantManagement.pleaseInputName': 'Please input tenant name',
  'tenantManagement.email': 'Email',
  'tenantManagement.searchEmail': 'Search by email',
  'tenantManagement.pleaseInputEmail': 'Please input email',
  'tenantManagement.pleaseInputValidEmail': 'Please input a valid email',
  'tenantManagement.phone': 'Phone',
  'tenantManagement.searchPhone': 'Search by phone',
  'tenantManagement.pleaseInputPhone': 'Please input phone number',
  'tenantManagement.leaseStart': 'Lease Start',
  'tenantManagement.leaseStartDate': 'Lease Start Date',
  'tenantManagement.pleaseInputLeaseStart': 'Please input lease start date',
  'tenantManagement.leaseEnd': 'Lease End',
  'tenantManagement.leaseEndDate': 'Lease End Date',
  'tenantManagement.monthlyRent': 'Monthly Rent',
  'tenantManagement.depositAmount': 'Deposit Amount',
  'tenantManagement.emergencyContactName': 'Emergency Contact Name',
  'tenantManagement.emergencyContactPhone': 'Emergency Contact Phone',
  'tenantManagement.notes': 'Notes',
  'tenantManagement.units': 'Units',
  'tenantManagement.assignUnits': 'Assign Units',
  'tenantManagement.selectUnits': 'Select units to assign',
  'tenantManagement.status': 'Status',
  'tenantManagement.active': 'Active',
  'tenantManagement.inactive': 'Inactive',
  'tenantManagement.createdAt': 'Created At',
  'tenantManagement.actions': 'Actions',
  // Tenant Modal
  'tenantManagement.delete': 'Delete',
  'tenantManagement.cancel': 'Cancel',
  'tenantManagement.deleteConfirmation':
    'Are you sure you want to delete this tenant? This action cannot be undone.',
  'tenantManagement.userAccountCreatedTitle': 'User Account Created:',
  'pages.siteDetail.siteDocuments.expiryDate': 'Expiry Date',
  'pages.siteDetail.siteDocuments.expiryDatePlaceholder': 'Select expiry date and time (optional)',
  'pages.siteDetail.siteDocuments.isActive': 'Active',
  'pages.siteDetail.siteDocuments.documentType.license': 'License',
  'pages.siteDetail.siteDocuments.documentType.contract': 'Contract',
  'pages.siteDetail.siteDocuments.documentType.permit': 'Permit',
  'pages.siteDetail.siteDocuments.documentType.certificate': 'Certificate',
  'pages.siteDetail.siteDocuments.documentType.managementCompany': 'Management Company',
  'pages.siteDetail.siteDocuments.documentType.publicLiabilityInsurance':
    'Public Liability Insurance',
  'pages.siteDetail.siteDocuments.documentType.propertyAllRisksInsurance':
    'Property All Risks Insurance',
  'pages.siteDetail.siteDocuments.documentType.thirdPartyLiabilityInsurance':
    'Third Party Liability Insurance',
  'pages.siteDetail.siteDocuments.documentType.fireInsurance': 'Fire Insurance',
  'pages.siteDetail.siteDocuments.documentType.workersCompensationInsurance':
    'Workers Compensation Insurance',
  'pages.siteDetail.siteDocuments.documentType.elevatorMaintenance': 'Elevator Maintenance',
  'pages.siteDetail.siteDocuments.documentType.elevatorLicense': 'Elevator License',
  'pages.siteDetail.siteDocuments.documentType.fireSafetyAnnualInspection':
    'Fire Safety Annual Inspection',
  'pages.siteDetail.siteDocuments.documentType.cleaningCompanyContract':
    'Cleaning Company Contract',
  'pages.siteDetail.siteDocuments.documentType.fireAlarmCompany': 'Fire Alarm Company',
  'pages.siteDetail.siteDocuments.documentType.cctvMaintenance': 'CCTV Maintenance',
  'pages.siteDetail.siteDocuments.documentType.freshWaterTankCleaning': 'Fresh Water Tank Cleaning',
  'pages.siteDetail.siteDocuments.documentType.saltWaterTankCleaning': 'Salt Water Tank Cleaning',
  'pages.siteDetail.siteDocuments.documentType.fireTankCleaning': 'Fire Tank Cleaning',
  'pages.siteDetail.siteDocuments.documentType.fiveYearElectricalTest':
    'Five Year Electrical Test (WR2)',
  'pages.siteDetail.siteDocuments.documentType.governmentOrder': 'Government Order',
  'pages.siteDetail.siteDocuments.documentType.meetingMinutes': 'Meeting Minutes',
  'pages.siteDetail.siteDocuments.documentType.expenseReport': 'Expense Report',
  'pages.siteDetail.siteDocuments.documentType.managementFeeReport': 'Management Fee Report',
  'pages.siteDetail.siteDocuments.documentType.emergencyNotice': 'Emergency Notice',
  'pages.siteDetail.siteDocuments.documentType.importantNotes': 'Important Notes',
  'pages.siteDetail.siteDocuments.documentType.other': 'Other',
  // Site Document Management
  'pages.siteDetail.siteDocuments': 'Site Documents',
  'pages.siteDetail.siteDocuments.create': 'Upload Document',
  'pages.siteDetail.siteDocuments.edit': 'Edit Document',
  'pages.siteDetail.siteDocuments.title': 'Title',
  'pages.siteDetail.siteDocuments.description': 'Description',
  'pages.siteDetail.siteDocuments.documentType': 'Document Type',
  'pages.siteDetail.siteDocuments.file': 'File',
  'pages.siteDetail.siteDocuments.fileOptional':
    'Optional: You can add a file attachment to this document',
  'pages.siteDetail.siteDocuments.attachment': 'Attachment',
  'pages.siteDetail.siteDocuments.noAttachment': 'No attachment',
  'pages.siteDetail.siteDocuments.expiryDays': 'Expiry Days',
  'pages.siteDetail.siteDocuments.isPublic': 'Public',
  'pages.siteDetail.siteDocuments.isExpired': 'Expired',
  'pages.siteDetail.siteDocuments.daysUntilExpiry': 'Days Until Expiry',
  'pages.siteDetail.siteDocuments.isExpiringSoon': 'Expiring Soon',
  'pages.siteDetail.siteDocuments.createdBy': 'Created By',
  'pages.siteDetail.siteDocuments.createdAt': 'Created At',
  'pages.siteDetail.siteDocuments.actions': 'Actions',
  'pages.siteDetail.siteDocuments.download': 'Download',
  'pages.siteDetail.siteDocuments.removeAttachment': 'Remove Attachment',
  'pages.siteDetail.siteDocuments.replaceAttachment': 'Replace Attachment',
  'pages.siteDetail.siteDocuments.newFileSelected': 'New file selected',
  'pages.siteDetail.siteDocuments.attachmentRemoved': 'Attachment removed successfully',
  'pages.siteDetail.siteDocuments.attachmentReplaced': 'Attachment replaced successfully',
  'pages.siteDetail.siteDocuments.actions.edit': 'Edit',
  'pages.siteDetail.siteDocuments.actions.delete': 'Delete',
  'pages.siteDetail.siteDocuments.actions.download': 'Download',
  'pages.siteDetail.siteDocuments.deleteConfirm': 'Are you sure you want to delete this document?',
  'pages.siteDetail.siteDocuments.deleteSuccess': 'Document deleted successfully',
  'pages.siteDetail.siteDocuments.createSuccess': 'Document uploaded successfully',
  'pages.siteDetail.siteDocuments.updateSuccess': 'Document updated successfully',
  'pages.siteDetail.siteDocuments.downloadSuccess': 'Document download started',

  // Site Document Management Page
  'siteDocumentManagement.fetchSitesError': 'Failed to fetch sites',
  'siteDocumentManagement.fetchDocumentTypesError': 'Failed to fetch document types',
  'siteDocumentManagement.deleteSuccess': 'Document deleted successfully',
  'siteDocumentManagement.deleteError': 'Failed to delete document',
  'siteDocumentManagement.noAttachment': 'No attachment available for download',
  'siteDocumentManagement.downloadError': 'Failed to download document',
  'siteDocumentManagement.title': 'Title',
  'siteDocumentManagement.site': 'Site',
  'siteDocumentManagement.documentType': 'Document Type',
  'siteDocumentManagement.expiryDate': 'Expiry Date',
  'siteDocumentManagement.noExpiry': 'No Expiry',
  'siteDocumentManagement.status': 'Status',
  'siteDocumentManagement.active': 'Active',
  'siteDocumentManagement.inactive': 'Inactive',
  'siteDocumentManagement.public': 'Public',
  'siteDocumentManagement.private': 'Private',
  'siteDocumentManagement.expired': 'Expired',
  'siteDocumentManagement.createdAt': 'Created At',
  'siteDocumentManagement.updatedAt': 'Updated At',
  'siteDocumentManagement.actions': 'Actions',
  'siteDocumentManagement.download': 'Download',
  'siteDocumentManagement.downloadAction': 'Download',
  'siteDocumentManagement.deleteConfirmTitle': 'Delete this document?',
  'siteDocumentManagement.yes': 'Yes',
  'siteDocumentManagement.no': 'No',
  'siteDocumentManagement.delete': 'Delete',
  'siteDocumentManagement.export': 'Export Excel',
  'siteDocumentManagement.exportSuccess': 'Export started successfully',
  'siteDocumentManagement.exportError': 'Failed to export documents',
  'siteDocumentManagement.search': 'Search',
  'siteDocumentManagement.searchPlaceholder': 'Search by title or description',
  'siteDocumentManagement.activeFilter': 'Active',
  'siteDocumentManagement.publicFilter': 'Public',
  'siteDocumentManagement.expiredFilter': 'Expired',
  'siteDocumentManagement.expiringSoonFilter': 'Expiring Soon',
  'siteDocumentManagement.titlePage': 'Site Document Management',
  'siteDocumentManagement.tableTitle': 'Site Documents',
  'siteDocumentManagement.refresh': 'Refresh',

  // Site Event Calendar
  'pages.siteDetail.eventCalendar.title': 'Site Event Calendar',
  'pages.siteDetail.eventCalendar.addEvent': 'Add Event',
  'pages.siteDetail.eventCalendar.createEvent': 'Create Event',
  'pages.siteDetail.eventCalendar.editEvent': 'Edit Event',
  'pages.siteDetail.eventCalendar.deleteEvent': 'Delete Event',
  'pages.siteDetail.eventCalendar.deleteConfirm': 'Are you sure you want to delete this event?',
  'pages.siteDetail.eventCalendar.delete': 'Delete Event',
  'pages.siteDetail.eventCalendar.deleteSuccess': 'Event deleted successfully',
  'pages.siteDetail.eventCalendar.createSuccess': 'Event created successfully',
  'pages.siteDetail.eventCalendar.updateSuccess': 'Event updated successfully',
  'pages.siteDetail.eventCalendar.operationFailed': 'Operation failed',
  'pages.siteDetail.eventCalendar.fetchFailed': 'Failed to fetch events',

  // Event Form Fields
  'pages.siteDetail.eventCalendar.form.title': 'Title',
  'pages.siteDetail.eventCalendar.form.titlePlaceholder': 'Enter event title',
  'pages.siteDetail.eventCalendar.form.titleRequired': 'Title is required',
  'pages.siteDetail.eventCalendar.form.description': 'Description',
  'pages.siteDetail.eventCalendar.form.descriptionPlaceholder': 'Enter event description',
  'pages.siteDetail.eventCalendar.form.eventType': 'Event Type',
  'pages.siteDetail.eventCalendar.form.eventTypePlaceholder': 'Select event type',
  'pages.siteDetail.eventCalendar.form.eventTypeRequired': 'Event type is required',
  'pages.siteDetail.eventCalendar.form.startDate': 'Start Date',
  'pages.siteDetail.eventCalendar.form.startDatePlaceholder': 'Select start date',
  'pages.siteDetail.eventCalendar.form.startDateRequired': 'Start date is required',
  'pages.siteDetail.eventCalendar.form.endDate': 'End Date',
  'pages.siteDetail.eventCalendar.form.endDatePlaceholder': 'Select end date',
  'pages.siteDetail.eventCalendar.form.endDateRequired': 'End date is required',
  'pages.siteDetail.eventCalendar.form.fullDay': 'Full Day Event',
  'pages.siteDetail.eventCalendar.form.startTime': 'Start Time',
  'pages.siteDetail.eventCalendar.form.startTimePlaceholder': 'Select start time',
  'pages.siteDetail.eventCalendar.form.endTime': 'End Time',
  'pages.siteDetail.eventCalendar.form.endTimePlaceholder': 'Select end time',
  'pages.siteDetail.eventCalendar.form.location': 'Location',
  'pages.siteDetail.eventCalendar.form.locationPlaceholder': 'Enter event location',
  'pages.siteDetail.eventCalendar.form.color': 'Color',
  'pages.siteDetail.eventCalendar.form.priority': 'Priority',
  'pages.siteDetail.eventCalendar.form.priorityPlaceholder': 'Select priority',
  'pages.siteDetail.eventCalendar.form.status': 'Status',
  'pages.siteDetail.eventCalendar.form.statusPlaceholder': 'Select status',
  'pages.siteDetail.eventCalendar.form.assignedTo': 'Assigned To',
  'pages.siteDetail.eventCalendar.form.assignedToPlaceholder': 'Select assigned staff',
  'pages.siteDetail.eventCalendar.form.isPublic': 'Public Event',
  'pages.siteDetail.eventCalendar.form.isActive': 'Active',
  'pages.siteDetail.eventCalendar.form.isRecurring': 'Recurring',
  'pages.siteDetail.eventCalendar.form.recurrenceRule': 'Recurrence Rule',
  'pages.siteDetail.eventCalendar.form.recurrenceRulePlaceholder': 'e.g., FREQ=MONTHLY;INTERVAL=1',

  // Event Types
  'pages.siteDetail.eventCalendar.eventType.maintenance': 'Maintenance',
  'pages.siteDetail.eventCalendar.eventType.inspection': 'Inspection',
  'pages.siteDetail.eventCalendar.eventType.visit': 'Visit',
  'pages.siteDetail.eventCalendar.eventType.holiday': 'Holiday',
  'pages.siteDetail.eventCalendar.eventType.custom': 'Custom',

  // Priority Levels
  'pages.siteDetail.eventCalendar.priority.low': 'Low',
  'pages.siteDetail.eventCalendar.priority.normal': 'Normal',
  'pages.siteDetail.eventCalendar.priority.high': 'High',
  'pages.siteDetail.eventCalendar.priority.urgent': 'Urgent',

  // Event Statuses
  'pages.siteDetail.eventCalendar.status.scheduled': 'Scheduled',
  'pages.siteDetail.eventCalendar.status.inProgress': 'In Progress',
  'pages.siteDetail.eventCalendar.status.completed': 'Completed',
  'pages.siteDetail.eventCalendar.status.cancelled': 'Cancelled',

  // Public Holiday Management
  'holidayManagement.title': 'Public Holiday Management',
  'holidayManagement.content': 'Manage public holidays for your organization',
  'holidayManagement.holidayList': 'Holiday List',
  'holidayManagement.addNewHoliday': 'Add New Holiday',
  'holidayManagement.editHoliday': 'Edit Holiday',
  'holidayManagement.addHoliday': 'Add Holiday',
  'holidayManagement.createSuccess': 'Holiday created successfully',
  'holidayManagement.updateSuccess': 'Holiday updated successfully',
  'holidayManagement.deleteSuccess': 'Holiday deleted successfully',
  'holidayManagement.deleteFailed': 'Delete failed',
  'holidayManagement.operationFailed': 'Operation failed',
  'holidayManagement.deleteConfirm': 'Are you sure you want to delete this holiday?',
  'holidayManagement.name': 'Holiday Name',
  'holidayManagement.description': 'Description',
  'holidayManagement.date': 'Date',
  'holidayManagement.countryCode': 'Country',
  'holidayManagement.stateCode': 'State/Region',
  'holidayManagement.isNational': 'National Holiday',
  'holidayManagement.status': 'Status',
  'holidayManagement.action': 'Action',
  'holidayManagement.edit': 'Edit',
  'holidayManagement.delete': 'Delete',
  'holidayManagement.yes': 'Yes',
  'holidayManagement.no': 'No',
  'holidayManagement.active': 'Active',
  'holidayManagement.inactive': 'Inactive',
  'holidayManagement.searchName': 'Search holiday name',
  'holidayManagement.searchDescription': 'Search description',
  'holidayManagement.holidayName': 'Holiday Name',
  'holidayManagement.pleaseEnterHolidayName': 'Please enter holiday name',
  'holidayManagement.pleaseSelectDate': 'Please select date',
  'holidayManagement.pleaseSelectCountry': 'Please select country',
  'holidayManagement.pleaseSelectState': 'Please select state/region',
  'holidayManagement.isActive': 'Active',
  'holidayManagement.showing': 'Showing',
  'holidayManagement.of': 'of',
  'holidayManagement.items': 'items',

  // Hong Kong Public Holiday Names
  'holidayManagement.holidayNames.newYearsDay': "New Year's Day",
  'holidayManagement.holidayNames.lunarNewYearsDay': "Lunar New Year's Day",
  'holidayManagement.holidayNames.secondDayOfLunarNewYear': 'Second Day of Lunar New Year',
  'holidayManagement.holidayNames.thirdDayOfLunarNewYear': 'Third Day of Lunar New Year',
  'holidayManagement.holidayNames.chingMingFestival': 'Ching Ming Festival',
  'holidayManagement.holidayNames.goodFriday': 'Good Friday',
  'holidayManagement.holidayNames.dayFollowingGoodFriday': 'Day following Good Friday',
  'holidayManagement.holidayNames.easterMonday': 'Easter Monday',
  'holidayManagement.holidayNames.labourDay': 'Labour Day',
  'holidayManagement.holidayNames.buddhaBirthday': 'The Birthday of the Buddha',
  'holidayManagement.holidayNames.tuenNgFestival': 'Tuen Ng Festival',
  'holidayManagement.holidayNames.hkEstablishmentDay':
    'Hong Kong Special Administrative Region Establishment Day',
  'holidayManagement.holidayNames.nationalDay': 'National Day',
  'holidayManagement.holidayNames.dayFollowingMidAutumn':
    'Day following the Chinese Mid-Autumn Festival',
  'holidayManagement.holidayNames.chungYeungFestival': 'Chung Yeung Festival',
  'holidayManagement.holidayNames.christmasDay': 'Christmas Day',
  'holidayManagement.holidayNames.firstWeekdayAfterChristmas':
    'The first weekday after Christmas Day',
  'holidayManagement.quickAddCommonHoliday': 'Quick Add Common Holiday',
  'holidayManagement.originalName': 'Original name',

  // Staff 468 Rule Tooltip
  'staff468Rule.loading': 'Loading working hours...',
  'staff468Rule.error': 'Error',
  'staff468Rule.noData': 'No data available',
  'staff468Rule.workingHoursSummary': 'Working Hours Summary (4 weeks)',
  'staff468Rule.totalHours': 'Total Hours:',
  'staff468Rule.threshold': 'Threshold:',
  'staff468Rule.extraHours': 'Extra Hours:',
  'staff468Rule.exceedsRule': '⚠️ EXCEEDS 468 RULE',
  'staff468Rule.withinRule': '✅ WITHIN 468 RULE',
  'staff468Rule.holidayCompliance': 'Holiday Compliance (7-day rule)',
  'staff468Rule.complianceRate': 'Compliance Rate:',
  'staff468Rule.compliantPeriods': 'Compliant Periods:',
  'staff468Rule.violations': 'Violations:',
  'staff468Rule.holidayCompliant': '✅ HOLIDAY COMPLIANT',
  'staff468Rule.holidayViolation': '⚠️ HOLIDAY VIOLATION',
  'staff468Rule.violationPeriods': 'Violation Periods:',
  'staff468Rule.days': 'days',
  'staff468Rule.moreViolations': '... and {count} more violations',
  'staff468Rule.calculationPeriod': 'Calculation Period:',
  'staff468Rule.recentAssignments': 'Recent Assignments ({count}):',
  'staff468Rule.moreAssignments': '... and {count} more assignments',
  'staff468Rule.ruleViolation': '⚠️ 468 RULE VIOLATION',
  'staff468Rule.ruleViolationMessage':
    'This staff member has exceeded the 68-hour threshold in the past 4 weeks. Additional approval may be required for new assignments.',
  'staff468Rule.holidayViolationTitle': '⚠️ HOLIDAY COMPLIANCE VIOLATION',
  'staff468Rule.holidayViolationMessage':
    'This staff member has not had at least one holiday in every 7-day period. Consider scheduling leave or adjusting assignments.',
  'staff468Rule.overnight': 'Overnight',
  'staff468Rule.staff': 'Staff:',

  // Shift Detail Tooltip Messages
  'shiftDetail.cannotAssignThreshold':
    'Cannot assign shift: Staff member has exceeded the 468 Rule threshold (68 hours in 4 weeks). Additional approval required.',
  'shiftDetail.cannotAssignHoliday':
    'Cannot assign shift: Staff member has holiday compliance violations (no holiday in 7-day period). Consider scheduling leave or adjusting assignments.',
  'shiftDetail.assignToThisShift': 'Assign to this shift',
  'shiftDetail.assignToOtherShift': 'Assign to other shift',
  'shiftDetail.markAsLeave': 'Mark as leave',
  'shiftDetail.ruleAndHolidayViolated': ' (468 Rule & Holiday Compliance Violated)',
  'shiftDetail.ruleExceeded': ' (468 Rule Exceeded)',
  'shiftDetail.holidayViolated': ' (Holiday Compliance Violated)',

  // Shift Detail Export
  'shiftDetail.exportExcel': 'Export Excel',
  'shiftDetail.exportSuccess': 'Export completed successfully',
  'shiftDetail.exportError': 'Export failed',

  // Staff Assignment Export
  'staffAssignment.backToShiftAssignment': 'Back to Shift Assignment',
  'staffAssignment.viewShiftDetail': 'View Shift Detail',
  'staffAssignment.selectShiftForDetail': 'Select Shift to View Detail',
  'staffAssignment.viewDetail': 'View Detail',
  'staffAssignment.selectShiftMessage': 'Choose which shift you would like to view in detail:',
  'staffAssignment.site': 'Site',
  'staffAssignment.selectSite': 'Select site',
  'staffAssignment.shift': 'Shift',
  'staffAssignment.selectShift': 'Select shift',
  'staffAssignment.leaveType': 'Leave Type',
  'staffAssignment.reason': 'Reason',
  'staffAssignment.preferredShifts': 'Preferred Shifts',
  'staffAssignment.clickForOptions': 'Click for options',
  'staffAssignment.exportExcel': 'Export Excel',
  'staffAssignment.exportSuccess': 'Export completed successfully',
  'staffAssignment.exportError': 'Export failed',

  // Staff Assignment Additional Translations
  'staffAssignment.assignShift': 'Assign Shift',
  'staffAssignment.assignLeave': 'Assign Leave',
  'staffAssignment.editAssignment': 'Edit Assignment',
  'staffAssignment.removeAssignment': 'Remove Assignment',
  'staffAssignment.updateLeave': 'Update Leave',
  'staffAssignment.deleteLeave': 'Delete Leave',
  'staffAssignment.editLeave': 'Edit Leave',
  'staffAssignment.addLeave': 'Add Leave',
  'staffAssignment.deleteLeaveTitle': 'Delete Leave',
  'staffAssignment.deleteLeaveMessage': 'Are you sure you want to delete this leave?',
  'staffAssignment.leaveDetails': 'Leave Details',
  'staffAssignment.delete': 'Delete',
  'staffAssignment.selectShiftPlaceholder': 'Select a shift',
  'staffAssignment.assignmentRemoved': 'Assignment removed successfully',
  'staffAssignment.assignmentRemoveFailed': 'Failed to remove assignment',
  'staffAssignment.leaveUpdated': 'Leave updated successfully',
  'staffAssignment.leaveCreated': 'Leave created successfully',
  'staffAssignment.leaveProcessFailed': 'Failed to process leave',
  'staffAssignment.leaveDeleted': 'Leave deleted successfully',
  'staffAssignment.leaveDeleteFailed': 'Failed to delete leave',
  'staffAssignment.manageLeave': 'Manage Leave',
  'staffAssignment.assignShiftTitle': 'Assign Shift',
  'staffAssignment.siteShift': 'Site - Shift',
  'staffAssignment.employeeId': 'Employee ID',
  'staffAssignment.phone': 'Phone',
  'staffAssignment.active': 'Active',
  'staffAssignment.inactive': 'Inactive',
  'staffAssignment.date': 'Date',
  'staffAssignment.type': 'Type',
  'staffAssignment.statutoryHoliday': 'Statutory Holiday',
  'staffAssignment.annualLeave': 'Annual Leave',
  'staffAssignment.noPayLeave': 'No Pay Leave',
  'staffAssignment.regularHoliday': 'Regular Holiday',
  'staffAssignment.compensationLeave': 'Compensation Leave',
  'staffAssignment.absenceWithoutLeave': 'Absence Without Leave',
  'staffAssignment.sickLeave': 'Sick Leave',
  'staffAssignment.unpaidSickLeave': 'Unpaid Sick Leave',

  // Attendance Management Export
  'attendance.exportExcel': 'Export Excel',
  'attendance.exportMonthly': 'Export Monthly Attendance',
  'attendance.exportSuccess': 'Attendance data exported successfully',
  'attendance.exportError': 'Failed to export attendance data',
  'attendance.exportTooltip': 'Export monthly attendance records to Excel file',
  'attendance.selectMonth': 'Select month for export',

  // Version Management
  'versionManagement.title': 'App Version Management',
  'versionManagement.versionList': 'Version List',
  'versionManagement.createVersion': 'Create Version',
  'versionManagement.editVersion': 'Edit Version',
  'versionManagement.versionDetail': 'Version Detail',
  'versionManagement.versionNumber': 'Version Number',
  'versionManagement.versionName': 'Version Name',
  'versionManagement.platform': 'Platform',
  'versionManagement.releaseType': 'Release Type',
  'versionManagement.status': 'Status',
  'versionManagement.releaseSummary': 'Release Summary',
  'versionManagement.releaseNotes': 'Release Notes',
  'versionManagement.features': 'New Features',
  'versionManagement.bugFixes': 'Bug Fixes',
  'versionManagement.improvements': 'Improvements',
  'versionManagement.breakingChanges': 'Breaking Changes',
  'versionManagement.minOsVersion': 'Minimum OS Version',
  'versionManagement.maxOsVersion': 'Maximum OS Version',
  'versionManagement.plannedReleaseDate': 'Planned Release Date',
  'versionManagement.forceUpdate': 'Force Update',
  'versionManagement.critical': 'Critical',
  'versionManagement.active': 'Active',
  'versionManagement.inactive': 'Inactive',
  'versionManagement.buildNumber': 'Build Number',
  'versionManagement.fileInfo': 'File Info',
  'versionManagement.viewFileInfo': 'View file info',
  'versionManagement.downloadFile': 'Download file',
  'versionManagement.flags': 'Flags',
  'versionManagement.createdAt': 'Created At',
  'versionManagement.updatedAt': 'Updated At',
  'versionManagement.actions': 'Actions',
  'versionManagement.edit': 'Edit',
  'versionManagement.detail': 'Detail',
  'versionManagement.approve': 'Approve',
  'versionManagement.release': 'Release',
  'versionManagement.deprecate': 'Deprecate',
  'versionManagement.approveConfirm': 'Are you sure to approve this version?',
  'versionManagement.releaseConfirm': 'Are you sure to release this version?',
  'versionManagement.deprecateConfirm': 'Are you sure to deprecate this version?',
  'versionManagement.createSuccess': 'Version created successfully',
  'versionManagement.createError': 'Failed to create version',
  'versionManagement.updateSuccess': 'Version updated successfully',
  'versionManagement.updateError': 'Failed to update version',
  'versionManagement.approveSuccess': 'Version approved successfully',
  'versionManagement.approveError': 'Failed to approve version',
  'versionManagement.releaseSuccess': 'Version released successfully',
  'versionManagement.releaseError': 'Failed to release version',
  'versionManagement.deprecateSuccess': 'Version deprecated successfully',
  'versionManagement.deprecateError': 'Failed to deprecate version',
  'versionManagement.downloadSuccess': 'File downloaded successfully',
  'versionManagement.downloadError': 'Failed to download file',
  'versionManagement.uploadSuccess': 'File uploaded successfully',
  'versionManagement.uploadError': 'Failed to upload file',
  'versionManagement.removeFileSuccess': 'File removed successfully',
  'versionManagement.removeFileError': 'Failed to remove file',
  'versionManagement.getFileInfoError': 'Failed to get file information',
  'versionManagement.basicInfo': 'Basic Information',
  'versionManagement.timestamps': 'Timestamps',
  'versionManagement.releaseDate': 'Release Date',
  'versionManagement.osRequirements': 'OS Requirements',
  'versionManagement.filename': 'Filename',
  'versionManagement.fileSize': 'File Size',
  'versionManagement.checksum': 'Checksum',
  'versionManagement.uploadedAt': 'Uploaded At',
  'versionManagement.uploadedBy': 'Uploaded By',
  'versionManagement.noFileAttached': 'No file attached to this version',
  'versionManagement.uploadFile': 'Upload File',
  'versionManagement.removeFile': 'Remove File',
  'versionManagement.removeFileConfirm': 'Are you sure to remove this file?',
  'versionManagement.versionNumberRequired': 'Please input version number',
  'versionManagement.platformRequired': 'Please select platform',
  'versionManagement.releaseTypeRequired': 'Please select release type',
  'versionManagement.appFile': 'App File (Optional)',
  'versionManagement.fileUploadHelp': 'Upload the app file (APK, IPA, ZIP, etc.) for this version',
  'versionManagement.selectFile': 'Select File',
  'versionManagement.selectedFile': 'Selected file',
};
